import { render } from "./CommandIconComponent.vue?vue&type=template&id=105b7390&scoped=true&ts=true"
import script from "./CommandIconComponent.ts?vue&type=script&lang=ts"
export * from "./CommandIconComponent.ts?vue&type=script&lang=ts"

import "./CommandIconComponent.scss?vue&type=style&index=0&id=105b7390&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105b7390"]])

export default __exports__